import { Fragment } from 'react';
import { WebSection, usePage } from '@wbk/contentful/api';
import FullpageAnimatedLogo from '@/components/ui/Loading/FullpageAnimatedLogo';
import ContentfulWebSection from '@/components/section/WebSection';
import PaginatedPageWrapper from '@/components/page/Wrapper';
import useLocalization from '@/context/localization/useLocalization';
import Seo from '@/components/headers/seo';
import Error404 from '@/components/error/404';

const Home = () => {
  const { locale } = useLocalization();
  const { data, isLoading, fetchNextPage, hasNextPage, error } = usePage({
    lang: locale,
    limit: 1,
    where: { slug: process.env.VITE_PUBLIC_PAGE_SLUG },
  });

  if (error) throw error;

  if (isLoading) return <FullpageAnimatedLogo />;

  if (!data) return <Error404 />;

  return (
    <>
      <Seo
        title={data.seo?.title || data.title}
        description={data.seo?.description}
        keywords={data.seo?.keywords}
        image={data.seo?.image?.url || data.background?.url}
      />
      <PaginatedPageWrapper hasNextPage={hasNextPage} fetchNextPage={fetchNextPage}>
        {data.sectionsCollection.items.map((section, idx) => (
          <Fragment key={section.__typename + idx}>
            <ContentfulWebSection section={section as WebSection} />
          </Fragment>
        ))}
      </PaginatedPageWrapper>
    </>
  );
};

export default Home;
